import styled from 'styled-components';
import { theme, toRem } from 'design';

export const SidebarFooter = styled.footer`
  position: relative;
  bottom: 0;
  z-index: ${theme.zIndex.sidebar + 1};
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: ${toRem(theme.sidebar.footer.height.small)};
  margin: ${toRem(22)} 0 0;
  padding-bottom: ${toRem(44)};
  background: linear-gradient(180deg, rgba(245, 246, 247, 0) 0%, #f5f6f7 33.1%);

  @media (min-width: ${theme.breakpoint.large}px) {
    position: sticky;
    align-items: flex-end;
    height: ${toRem(theme.sidebar.footer.height.medium)};
    margin: 0;
    padding: 0 0 ${toRem(44)};
  }

  @media (min-width: ${theme.breakpoint.large}px) and (max-height: 768px) {
    position: relative;
  }

  button {
    width: ${toRem(110)};

    &:last-child {
      margin-left: ${toRem(11)};
    }
    &:first-child {
      margin-left: 0;
    }
  }
`;

export const SidebarTermsFooter = styled(SidebarFooter)`
  flex-flow: column nowrap;
  align-items: center;
  background: linear-gradient(180deg, rgba(245, 246, 247, 0) 0%, #f5f6f7 14.1%);

  padding: ${toRem(28)} ${toRem(theme.layout.gutter.small)} ${toRem(5)};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: ${toRem(24)} ${toRem(theme.layout.gutter.large)} ${toRem(5)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    height: ${toRem(theme.sidebar.footer.height.large)};
    padding: 0 ${toRem(33)} ${toRem(5)};
  }
`;
